import { Route, Routes, useResolvedPath } from 'react-router-dom'
import SystemView from './SystemView'
import LineView from './LineView'

const QRARoutes = () => {
  const resolvedPath = useResolvedPath('')
  const qraBasePath = resolvedPath.pathname

  return (
    <Routes>
      <Route
        path='line/:lineId/*'
        element={<LineView qraBasePath={qraBasePath} />}
      />
      <Route path='*' element={<SystemView qraBasePath={qraBasePath} />} />
    </Routes>
  )
}

export default QRARoutes
